import { PTableCell, PTableRow } from "@porsche-design-system/components-react"
import { Skeleton } from "src/components"
import { equipmentListMessages } from "./equipmentList.messages"

export const EquipmentListSkeleton = () => (
	<Skeleton.Table
		caption="Equipment List"
		headings={[
			equipmentListMessages.headerVisible,
			equipmentListMessages.headerName,
			equipmentListMessages.headerCode,
			equipmentListMessages.headerCategory,
		]}
		renderCustomRow={(i) => (
			<PTableRow key={i}>
				<PTableCell>
					<Skeleton $height="28px" $width="28px" />
				</PTableCell>
				<PTableCell>
					<Skeleton.Text $width="50%" />
				</PTableCell>
				<PTableCell>
					<Skeleton.Text $width="50%" />
				</PTableCell>
				<PTableCell>
					<Skeleton.Text $width="50%" />
				</PTableCell>
			</PTableRow>
		)}
		rows={5}
	/>
)
